function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function cleanItemName(item) {
  if (!item?.name) return item;

  // Function to clean a string safely
  const cleanName = (originalName, extraDetails) => {
    let name = originalName;

    // Remove brand_name if present
    if (extraDetails?.brand_name) {
      const brand = escapeRegex(extraDetails.brand_name.toLowerCase());
      const brandRegex = new RegExp(`\\(${brand}\\)`, "i");
      name = name.replace(brandRegex, "").trim();
    }

    // Remove serving_description if present
    if (extraDetails?.serving?.serving_description) {
      const serving = escapeRegex(
        extraDetails.serving.serving_description.toLowerCase()
      );
      const servingRegex = new RegExp(`\\(${serving}\\)`, "i");
      name = name.replace(servingRegex, "").trim();
    }

    // Cleanup: remove extra spaces and empty ()
    name = name
      .replace(/\s+/g, " ")
      .replace(/\(\s*\)/g, "")
      .trim();

    return name;
  };

  const newName = cleanName(item.name, item.extraDetails);

  return {
    ...item,
    name: newName
  };
}

export default cleanItemName;
